(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/freja/other-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/freja/other-device.js');

'use strict';

const AuthenticateEvents = svs.accountservices.authenticate.definitions.Events;
svs.player_login.views.freja.OtherDevice = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.freja_other_device(data);
  },
  ui: {
    qrContainer: '.js-qr-container',
    qrHelp: '.js-qr-help',
    retryButton: '.js-retry',
    qrSpinner: '.js-qr-spinner',
    prolongBtn: '.js-prolong-btn',
    qrCountdown: '.js-qr-countdown',
    qrCountdownAria: '.js-qr-countdown-aria',
    prolongQr: '.js-prolong-qr'
  },
  behaviors: {
    About: {
      behaviorClass: svs.player_login.behaviors.About
    },
    Login: {
      behaviorClass: svs.player_login.behaviors.Login
    },
    Navigation: {
      behaviorClass: svs.player_login.behaviors.Navigation
    }
  },
  events: {
    'click @ui.qrHelp': 'onQrHelpClick',
    'click @ui.retryButton': 'onRetryClick',
    'click @ui.prolongBtn': 'onRetryClick'
  },
  initialize() {
    this.authenticateEvents = {
      [AuthenticateEvents.READY_TO_POLL]: this.onReadyToPoll,
      [AuthenticateEvents.RETRY]: this.generateQR,
      [AuthenticateEvents.RETRIES_FINISHED]: this.onRetriesFinished,
      [AuthenticateEvents.ONE_RETRY_LEFT]: this.onOneRetryLeft
    };
    svs.accountservices.authenticate.login.on(this.authenticateEvents, this);
  },
  onAttach() {
    this.loader = new svs.ui.Loader(this.getUI('qrSpinner'));
    this.loader.show(300, 'inverted');
    svs.accountservices.authenticate.login.start({
      method: svs.accountservices.authenticate.definitions.LoginMethods.FREJA,
      qr: true,
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onBeforeError() {
    this.loader.hide();
  },
  onError() {
    this.getUI('prolongQr').addClass('hide');
    this.getUI('qrContainer').empty().html(svs.player_login.templates.get_new_qr());
  },
  onOneRetryLeft() {
    this.retryTimeOut = setTimeout(() => {
      this.getUI('qrCountdown').text('30');
      this.getUI('prolongQr').removeClass('hide');
      this.getUI('qrCountdownAria').text('30').parent().attr('role', 'alert');
      let countdown = 29;
      let countdownAria = 30;
      const ariaInterval = 10;
      this.interval = setInterval(() => {
        if (countdown >= 0) {
          this.getUI('qrCountdown').text(countdown--);
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
      this.intervalAria = setInterval(() => {
        if (countdown > 0) {
          countdownAria = countdownAria - ariaInterval;
          this.getUI('qrCountdownAria').text(countdownAria);
        } else {
          clearInterval(this.intervalAria);
        }
      }, 1000 * ariaInterval);
    }, 90000); 
  },
  onRetryClick() {
    this.getUI('qrContainer').empty().html(svs.player_login.templates.qr_spinner());
    this.getUI('prolongQr').addClass('hide');
    this.bindUIElements();
    this.loader = new svs.ui.Loader(this.getUI('qrSpinner'));
    this.loader.show(300, 'inverted');
    svs.accountservices.authenticate.login.start({
      method: svs.accountservices.authenticate.definitions.LoginMethods.FREJA,
      qr: true,
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onReadyToPoll(data) {
    this.loader.hide();
    this.model.set('loginToken', data.loginToken);
    this.generateQR(data);
    svs.accountservices.authenticate.login.poll();
  },
  onRetriesFinished() {
    this.getUI('qrContainer').empty().html('<p aria-live="polite" role="alert" class="padding-top-4">Inloggningen tog för lång tid.</p>');
  },
  generateQR() {
    this.getUI('qrContainer').empty().qrcode({
      size: 120,
      color: '#3a3',
      text: svs.accountservices.authenticate.login.getAppUrl()
    });
  },
  onQrHelpClick() {
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
      title: ' ',
      icon: 'help-2',
      actions: [{
        title: 'Stäng'
      }],
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.LEFT,
        text: "<div tabindex=\"0\">1. \xD6ppna din Freja eID-app i din mobila enhet.<br>\n                   2. V\xE4lj QR-kod/QR-Code.<br>\n                   3. L\xE4s av QR-koden med din mobila enhet.<br>\n                   4. Identifiera dig med kod eller fingeravtryck i Freja eID-appen.</div>"
      }]
    }));
  },
  onDestroy() {
    clearTimeout(this.retryTimeOut);
    clearInterval(this.intervalAria);
    clearInterval(this.interval);
    svs.accountservices.authenticate.login.off(this.authenticateEvents);
    svs.accountservices.authenticate.login.cancel();
  }
});

 })(window);